import { DownOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Flex, Menu, Space } from "antd";
import { getUsername, logout } from "../../services/authService";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { useAuth } from "../../contexts/authContext";

const UserMenu: React.FC = () => {
  const { logoutContext } = useAuth();
  const username = getUsername();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    logoutContext();
    navigate(`${routes.HOME}`);
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined />}>
        <Link to={routes.PROFILE}>Profilo</Link>
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Flex
      align="center"
      justify="flex-end"
      style={{ height: "100%", paddingRight: "16px" }}
    >
      <Dropdown overlay={userMenu} trigger={["click"]}>
        <a onClick={(e) => e.preventDefault()} style={{ color: "#001529" }}>
          <Space>
            <Avatar icon={<UserOutlined />} />
            {username}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </Flex>
  );
};
export default UserMenu;
